module.exports = __webpack_public_path__ + "static/media/frameDefault.4b61fe0c.png";